module.exports = __webpack_public_path__ + "img/Flag_of_Tokelau.c7fa3959.svg";